import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../../assets/Icons";
import OwnerAccountItemisedReportComp from "../../../../../components/Accounts/OwnerAccount/OwnerAccountConsolidatedLiveStatementComp";
import LargePopupRedirect from "../../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopupWithInput from "../../../../../components/_utils/CommonSmallPopupWithInput";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import CommonToast from "../../../../../components/_utils/CommonToast";
import UniversalRefreshToast from "../../../../../components/_utils/UniversalRefreshToast";
import {
  getAssociatedConsolidatedStatements,
  getAssociatedItemisedStatements,
  remitterAccountApprove,
  remitterAccountDetailsById,
  remitterAccountReject,
  removeUnmatchConsolidatedStatement,
  removeUnmatchItemisedStatement,
} from "../../../../../redux/features/accounts/remitterAccount/remitterAccount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../../utils/configurationProvider";
import OwnerAccountConsolidatedBankStatement from "../../../OwnerAccount/OwnerAccountConsolidatedBankStatement";
import SmallPopupWithBulletPoints from "../../../../../components/_utils/CommonSmallPopupWithBulletPoint";

const RemitterAccountEditSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState(false);
  const [showRejectLoader, setShowRejectLoader] = useState(false);
  const [showApproveLoader, setShowApproveLoader] = useState(false);
  const [rejectPopup, setRejectPopup] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [rejectBankStatement, setrejectBankStatement] = useState(false);
  const [rejectLiveStatement, setRejectLiveStatement] = useState(false);
  const [isService, setIsService] = useState(false);
  const services = useSelector((state) => state.refreshToken.services);
  const hasUnmatchPermission = services?.some(
    (service) => service === "RMapping" || service === "Admin",
  );


  const hasMatchPermission =
    services?.includes("Admin") ||
    (services?.includes("AMapping") && services?.includes("VAccountBalance"));

  const hasLiveMatchPermission =
    services?.includes("Admin") ||
    (services?.includes("AMapping") &&
      services?.includes("VItemisedStatement"));

  const { remitterAccountDetailsData, remitterAccountDetailsLoading } =
    useSelector((state) => state.remitterAccount);

  const remitterAccountData = remitterAccountDetailsData;

  const viewDetailsHandler = () => {
    navigate(
      `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${id}`,
      {
        replace: true,
      },
    );
  };

  const dashboardHandler = () => {
    navigate("/remitter_account_dashboard", {
      replace: true,
    });
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const handleRejectBankStatement = async () => {
    setShowLoader(true);
    UniversalRefreshToast("Unmatching transactions.");

    const remitterid =
      !remitterAccountDetailsLoading &&
      remitterAccountDetailsData?.mapped_consolidated_statement_entries
        ?.length > GlobalConfiguration.lengthCheckZero
        ? remitterAccountDetailsData?.mapped_consolidated_statement_entries?.map(
            (data) => data?.id,
          )
        : [];

    try {
      const response = await dispatch(
        removeUnmatchConsolidatedStatement({
          remitter_accounts_ids: [remitterAccountDetailsData?.id],
          mapping_ids: Array.isArray(remitterid) ? remitterid : [remitterid],
        }),
      );

      if (response?.payload?.status === true) {
        CommonToast({
          text: `${remitterid?.length === GlobalConfiguration.lengthCheckOne ? "Transaction" : "Transactions"} unmatched successfully.`,
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
        setShowLoader(false);

        await dispatch(remitterAccountDetailsById({ id: id }));

        if (
          remitterAccountData?.mapped_itemised_consolidated_statement_entries
            ?.length > GlobalConfiguration.lengthCheckZero
        ) {
          setRejectLiveStatement(true);
          setrejectBankStatement(false);
          setRejectPopup(false);
        } else {
          handleDeclined(id, declineReason);
        }
      } else {
        CommonToast({
          text:
            response?.payload?.message ||
            response?.payload?.errors?.base?.[0] ||
            "Failed to unmatch transactions.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setShowLoader(false);
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const handleRejectLiveStatement = async () => {
    UniversalRefreshToast("Unmatching transactions.");

    const remid =
      !remitterAccountDetailsLoading &&
      remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries
        ?.length > GlobalConfiguration.lengthCheckZero
        ? remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries?.map(
            (data) => data?.id,
          )
        : [];

    try {
      const response = await dispatch(
        removeUnmatchItemisedStatement({
          remitter_accounts_ids: [remitterAccountDetailsData?.id],
          mapping_ids: Array.isArray(remid) ? remid : [remid],
        }),
      );

      if (response?.payload?.status === true) {
        CommonToast({
          text: `${remid?.length === GlobalConfiguration.lengthCheckOne ? "Transaction" : "Transactions"} unmatched successfully.`,
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setRejectLiveStatement(false);
        await dispatch(remitterAccountDetailsById({ id: id }));
        handleDeclined(id, declineReason);
      } else {
        CommonToast({
          text:
            response?.payload?.message ||
            response?.payload?.errors?.base?.[0] ||
            "Failed to unmatch transactions.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const accountApproval = () => {
    (async () => {
      setShowApproveLoader(true);
      toast.dismiss();
      UniversalRefreshToast("approvalaccountsRefresh");
      let response = await dispatch(remitterAccountApprove({ id }));
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Account approved successfully.",
          variant: "var(--success)",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          buttonNeeded: false,
        });

        navigate(
          `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${id}`,
          { replace: true },
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.remitter_account[0],
          variant: "var(--error)",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        });
      }
    })();
  };
  const accountRejected = () => {
    (async () => {
      setShowRejectLoader(true);
      toast.dismiss();
      UniversalRefreshToast("accountsRefresh");
      if (
        remitterAccountDetailsData?.mapped_consolidated_statement_entries
          ?.length > GlobalConfiguration.lengthCheckZero
      ) {
        setrejectBankStatement(true);
        setRejectPopup(false);
      } else if (
        remitterAccountDetailsData
          ?.mapped_itemised_consolidated_statement_entries?.length >
        GlobalConfiguration.lengthCheckZero
      ) {
        setRejectLiveStatement(true);
        setRejectPopup(false);
      } else {
        setRejectPopup(false);
        handleDeclined(id, declineReason);
      }
    })();
  };

  const unamtchAllTxn = async () => {
    const remitterAccountId = id;

    const bankCount =
      remitterAccountDetailsData?.mapped_consolidated_statement_entries_count ??
      0;

    const liveCount =
      remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count ??
      0;

    const pageSize = PaginationConfiguration.paginationSmall;

    try {
      toast.dismiss();
      UniversalRefreshToast("Unmatching transactions and rejecting account.");

      let remitterIds = [];

      if (bankCount > GlobalConfiguration.lengthCheckZero) {
        const totalBankPages = Math.ceil(bankCount / pageSize);

        for (
          let page = GlobalConfiguration.lengthCheckOne;
          page <= totalBankPages;
          page++
        ) {
          const consolidatedResponse = await dispatch(
            getAssociatedConsolidatedStatements({
              page_no: page,
              page_size: pageSize,
              remitter_account_id: remitterAccountId,
            }),
          ).unwrap();

          const consolidatedStatements = consolidatedResponse?.statement || [];

          const pageIds = consolidatedStatements
            .map((data) => data?.account_statement_entry_id)
            .filter(Boolean);

          remitterIds = [...remitterIds, ...pageIds];
        }
      }

      if (remitterIds.length > GlobalConfiguration.lengthCheckZero) {
        await dispatch(
          removeUnmatchConsolidatedStatement({
            remitter_accounts_ids: [remitterAccountId],
            mapping_ids: remitterIds,
          }),
        ).unwrap();
      }

      let itemisedIds = [];

      if (liveCount > GlobalConfiguration.lengthCheckZero) {
        const totalLivePages = Math.ceil(liveCount / pageSize);

        for (
          let page = GlobalConfiguration.lengthCheckOne;
          page <= totalLivePages;
          page++
        ) {
          const itemisedResponse = await dispatch(
            getAssociatedItemisedStatements({
              page_no: page,
              page_size: pageSize,
              remitter_account_id: remitterAccountId,
            }),
          ).unwrap();

          const itemisedStatements =
            itemisedResponse?.ecollection_callbacks || [];

          const pageIds = itemisedStatements
            .map((data) => data?.ecollection_callback_id)
            .filter(Boolean);

          itemisedIds = [...itemisedIds, ...pageIds];
        }
      }

      if (itemisedIds.length > GlobalConfiguration.lengthCheckZero) {
        await dispatch(
          removeUnmatchItemisedStatement({
            remitter_accounts_ids: [remitterAccountId],
            mapping_ids: itemisedIds,
          }),
        ).unwrap();
      }

      toast.dismiss();

      CommonToast({
        text: "Transactions unmatched and account rejected successfully.",
        variant: "var(--success)",
        icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        buttonNeeded: false,
      });

      handleDeclined(id, declineReason);
    } catch (error) {
      toast.dismiss();

      CommonToast({
        text:
          error?.message ||
          error?.errors?.user_unauthorized?.[0] ||
          "Something went wrong while unmatching transactions.",
        variant: "var(--error)",
        icon: ICONS.ERROR,
        buttonNeeded: false,
      });
    }
  };

  // const unamtchAllTxn = async () => {
  //   try {
  //     setShowRejectLoader(true);
  //     toast.dismiss();
  //     UniversalRefreshToast("Unmatching transactions and rejecting account.");

  //     const consolidatedResponse = await dispatch(
  //       getAssociatedConsolidatedStatements({
  //         page_no: GlobalConfiguration.lengthCheckOne,
  //         page_size: PaginationConfiguration.paginationSmall,
  //         remitter_account_id: id,
  //       }),
  //     );

  //     const consolidatedStatements =
  //       consolidatedResponse?.payload?.statement || [];

  //     const remitterid = consolidatedStatements
  //       .map((data) => data?.account_statement_entry_id)
  //       .filter(Boolean);

  //     if (remitterid.length > GlobalConfiguration.lengthCheckZero) {
  //       await dispatch(
  //         removeUnmatchConsolidatedStatement({
  //           remitter_accounts_ids: [remitterAccountDetailsData?.id],
  //           mapping_ids: remitterid,
  //         }),
  //       );
  //     }

  //     if (
  //       remitterAccountData?.mapped_itemised_consolidated_statement_entries_count >
  //       GlobalConfiguration.lengthCheckZero
  //     ) {
  //       const itemisedResponse = await dispatch(
  //         getAssociatedItemisedStatements({
  //           page_no: GlobalConfiguration.lengthCheckOne,
  //           page_size: PaginationConfiguration.paginationSmall,
  //           remitter_account_id: id,
  //         }),
  //       );

  //       const itemisedStatements =
  //         itemisedResponse?.payload?.ecollection_callbacks || [];

  //       const remid = itemisedStatements
  //         .map((data) => data?.ecollection_callback_id)
  //         .filter(Boolean);

  //       // 4. Remove unmatched itemised statements
  //       if (remid.length > GlobalConfiguration.lengthCheckZero) {
  //         await dispatch(
  //           removeUnmatchItemisedStatement({
  //             remitter_accounts_ids: [remitterAccountDetailsData?.id],
  //             mapping_ids: remid,
  //           }),
  //         );
  //       }
  //     }
  //     toast.dismiss();
  //     CommonToast({
  //       text: "Transactions unmatched and account rejected successfully.",
  //       variant: "var(--success)",
  //       icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
  //       buttonNeeded: false,
  //     });
  //     handleDeclined(id, declineReason);
  //   } catch (error) {
  //     console.error("Error while unmatching all transactions:", error);
  //   } finally {
  //     setRejectPopup(false);
  //     setShowRejectLoader(false);
  //   }
  // };

  const handleDeclined = async (id, declineReason) => {
    let response = await dispatch(
      remitterAccountReject({
        id,
        rejection_reason: declineReason,
      }),
    );
    if (response?.payload?.status) {
      if (
        remitterAccountData?.mapped_consolidated_statement_entries_count >
          GlobalConfiguration.lengthCheckZero ||
        remitterAccountData?.mapped_itemised_consolidated_statement_entries_count >
          GlobalConfiguration.lengthCheckZero
      ) {
      } else {
        toast.dismiss();
        CommonToast({
          text: "Account rejected successfully.",
          variant: "var(--success)",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        });
      }

      navigate(
        `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${id}`,
        { replace: true },
      );
    } else {
      toast.dismiss();
      CommonToast({
        text: response?.payload?.errors?.remitter_account[0],
        variant: "var(--error)",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
      });
      setDeclineReason("");
      setShowRejectLoader(false);
      setRejectPopup(false);
    }
  };

  const consolidatedBankHandler = () => {
    navigate("/owner_account_dashboard/consolidated_bank_statement", {
      state: {
        data: id,
        remName: remitterAccountData?.name,
        flow: "remitter_edit_match_statement",
      },
      replace: true,
    });
  };

  const liveBankHandler = () => {
    navigate(`/owner_account_dashboard/consolidated_live_statement`, {
      state: {
        flow: "remitter_edit_match_statement",
        remName: remitterAccountData?.name,
        data: id,
      },
      replace: true,
    });
  };

  const handleInputChange = (event) => {
    let value = event?.target?.value;
    value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    value = value.replace(/^\s+/, "");
    value = value.replace(/\s{2,}/g, " ");
    value = value.slice(0, 150);
    setDeclineReason(value);
  };

  const primaryBtn = {
    enabledBgColor: "var(--text-primary)",
    enabledTextColor: "var(--positive-bg)",
    iconToBeAlign: "left",
    fullWidthRequired: true,
    imgColor: "var(--positive-bg)",
    hoverOption: "dark",
  };

  const outlineBtn = {
    enabledBgColor: "var(--bg-positive-bg)",
    enabledTextColor: "var(--text-primary)",
    iconToBeAlign: "left",
    fullWidthRequired: true,
    outLineColor: "var(--text-primary)",
    hoverOption: "dark",
  };

  const buttonRows = [
    ...(services?.includes("REAAccount") ||
    (services?.includes("Admin") &&
      remitterAccountData?.approval_status === "pending")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              handleFunction: () => {
                const hasBankTransactions =
                  remitterAccountDetailsData?.mapped_consolidated_statement_entries_count >
                  GlobalConfiguration.lengthCheckZero;

                const hasLiveTransactions =
                  remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count >
                  GlobalConfiguration.lengthCheckZero;

                if (
                  (hasBankTransactions || hasLiveTransactions) &&
                  !hasUnmatchPermission
                ) {
                  setIsService(true);
                } else {
                  setRejectPopup(true);
                }
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
              isLoaderNeeded: showRejectLoader,
              isLoading: showRejectLoader,
              isDisabled: showApproveLoader,
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              handleFunction: () => {
                accountApproval();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,

              isLoaderNeeded: showApproveLoader,
              isLoading: showApproveLoader,
              isDisabled: showRejectLoader,
            },
          ],
        ]
      : []),

    [
      {
        ...primaryBtn,
        btnText: "Match in bank statement",
        icon: ICONS?.MATCHED_WITH_CIRCLE,
        handleFunction: () => {
          if (hasMatchPermission) {
            !showApproveLoader && consolidatedBankHandler();
          } else {
             const requiredServices = ["AMapping", "VAccountBalance"];

            const unavailableServices = requiredServices.filter(
              (service) => !services?.includes(service),
            );

            navigate("/feature_not_assigned", {
              state: {
                unavailableService: unavailableServices,
              },
            });
          }
          
        },
        isDisabled: showRejectLoader || showApproveLoader || !hasMatchPermission,
      },
      {
        ...primaryBtn,
        btnText: "Match in live statement",
        icon: ICONS?.MATCHED_WITH_CIRCLE,
        handleFunction: () => {
          if (hasLiveMatchPermission) {
            !showApproveLoader && liveBankHandler();
          } else {
             const requiredServices = ["AMapping", "VItemisedStatement"];

            const unavailableServices = requiredServices.filter(
              (service) => !services?.includes(service),
            );

            navigate("/feature_not_assigned", {
              state: {
                unavailableService: unavailableServices,
              },
            });
          }
          
        },
        isDisabled: showRejectLoader || showApproveLoader || !hasLiveMatchPermission,
      },

      {
        ...primaryBtn,
        btnText: "View details",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: () => {
          !showApproveLoader && viewDetailsHandler();
        },
        isDisabled: showRejectLoader || showApproveLoader,
      },
      {
        ...outlineBtn,
        btnText: "Go to dashboard",
        icon: ICONS.GO_TO_DASHBOARD,
        handleFunction: () => {
          !showApproveLoader && dashboardHandler();
        },
        isDisabled: showRejectLoader || showApproveLoader,
        imgColor: "var(--text-primary)",
      },
    ],
  ];

  useEffect(() => {
    if (id) {
      dispatch(remitterAccountDetailsById({ id }));
    }
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <div>
      {isService && (
        <>
          {" "}
          <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"></div>
          <SmallPopupWithBulletPoints
            headerTitle="Matched transactions found"
            secondHeaderFontWeight={true}
            secondHeaderTitle="Feature not assigned for unmatching transactions."
            subtext="Contact an authorised person who has the feature to unmatch the following transactions before rejecting this account."
            bulletPoints={[
              ...(remitterAccountDetailsData?.mapped_consolidated_statement_entries_count >
              GlobalConfiguration.lengthCheckZero
                ? [
                    `Consolidated bank statement: ${remitterAccountDetailsData?.mapped_consolidated_statement_entries_count} transactions`,
                  ]
                : []),

              ...(remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count >
              GlobalConfiguration.lengthCheckZero
                ? [
                    `Consolidated live statement: ${remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count} transactions`,
                  ]
                : []),
            ]}
            btnOneHandleFunction={() => {
              setIsService(false);
            }}
            btnOneText="Cancel"
            btnTwoHandleFunction={() => {
              return;
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Unmatch & reject"
            btnTwoEnabledBgColor="var(--text-disabled)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoIsDisabled={true}
            btnTwoInActiveVariantNeeded={true}
            btnTwoHoverOption="black"
          />
        </>
      )}

      {rejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Reject account"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Provide the reason for rejection."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteText="Minimum 10 characters required."
            bulletPoints={[
              "Once rejected, this account can no longer be used for matching the transactions.",

              ...(remitterAccountDetailsData?.mapped_consolidated_statement_entries_count >
                0 ||
              remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count >
                0
                ? [
                    {
                      text: "Rejecting this account will also unmatch the following transactions:",
                      subPoints: [
                        ...(remitterAccountDetailsData?.mapped_consolidated_statement_entries_count >
                        0
                          ? [
                              `Bank transactions: ${remitterAccountDetailsData.mapped_consolidated_statement_entries_count}`,
                            ]
                          : []),

                        ...(remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count >
                        0
                          ? [
                              `Live transactions: ${remitterAccountDetailsData.mapped_itemised_consolidated_statement_entries_count}`,
                            ]
                          : []),
                      ],
                    },
                  ]
                : []),
            ]}
            // isTextInputField={true}
            inputAdornment={""}
            noteColor="text-secondary"
            inputPlaceholder={"Reason"}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showRejectLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showRejectLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              setRejectPopup(false);
              setDeclineReason("");
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText={
              remitterAccountData?.mapped_consolidated_statement_entries_count >
                GlobalConfiguration.lengthCheckZero ||
              remitterAccountData?.mapped_itemised_consolidated_statement_entries_count >
                GlobalConfiguration.lengthCheckZero
                ? "Unmatch & reject"
                : "Reject"
            }
            btnTwoHandleFunction={() => {
              if (
                remitterAccountData?.mapped_consolidated_statement_entries_count >
                  GlobalConfiguration.lengthCheckZero ||
                remitterAccountData?.mapped_itemised_consolidated_statement_entries_count >
                  GlobalConfiguration.lengthCheckZero
              ) {
                if (hasUnmatchPermission) {
                  unamtchAllTxn();
                } else {
                  navigate("/feature_not_assigned", {
                    state: {
                      unavailableService: "RMapping",
                    },
                  });
                }
              } else {
                accountRejected();
              }

              // setDeclineReason("");
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !hasUnmatchPermission
                ? true
                : declineReason.trim().length <
                    GlobalConfiguration.rejectReasonMinLength
                  ? true
                  : false
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showRejectLoader ? true : false}
            btnTwoIsLoading={showRejectLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      {rejectBankStatement && (
        <div className="fixed top-top-base left-left-base w-full h-full  bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <LargePopupRedirect
            headerTitle="Unmatch from consolidated bank statement"
            headersubtext="The following transactions are matched and need to be unmatched before rejecting this account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setrejectBankStatement(false);
              setDeclineReason("");
              setShowLoader(false);
              setShowRejectLoader(false);
            }}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              hasUnmatchPermission
                ? "To reject the account, please unmatch the transactions listed above by clicking the “Unmatch all” button."
                : "To unmatch the transactions, please contact the authorised person who has the feature to unmatch the transactions."
            }
            isbottomSectionneed={true}
            isDisabled={!hasUnmatchPermission}
            btnText={"Unmatch all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              if (hasUnmatchPermission) {
                handleRejectBankStatement();
              } else {
                navigate("/feature_not_assigned", {
                  state: {
                    unavailableService: "RMapping",
                  },
                });
              }
            }}
            isLoaderNeeded={true}
            isLoading={showLoader ? true : false}
            enabledBgColor={
              hasUnmatchPermission
                ? "var(--negative-act)"
                : "var(--text-disabled)"
            }
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            <OwnerAccountConsolidatedBankStatement
              popType={"remitterBankStatement"}
              flow={"rejectStatementdetails"}
              remitter_account_id={id}
              setViewstatementOpenPop={() => setrejectBankStatement(false)}
            />
          </LargePopupRedirect>
        </div>
      )}
      {rejectLiveStatement && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <LargePopupRedirect
            headerTitle="Unmatch from consolidated live statement"
            headersubtext="The following transactions are matched and need to be unmatched before rejecting this account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setRejectLiveStatement(false);
              setDeclineReason("");
              setShowLoader(false);
              setShowRejectLoader(false);
            }}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              hasUnmatchPermission
                ? "To reject the account, please unmatch the transactions listed above by clicking the “Unmatch all” button."
                : "To unmatch the transactions, please contact the authorised person who has the feature to unmatch the transactions."
            }
            isbottomSectionneed={true}
            btnText={"Unmatch all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              if (hasUnmatchPermission) {
                handleRejectLiveStatement();
              } else {
                navigate("/feature_not_assigned", {
                  state: {
                    unavailableService: "RMapping",
                  },
                });
              }
            }}
            isLoaderNeeded={true}
            isLoading={showLoader ? true : false}
            enabledBgColor={
              hasUnmatchPermission
                ? "var(--negative-act)"
                : "var(--text-disabled)"
            }
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={!hasUnmatchPermission}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            <OwnerAccountItemisedReportComp
              popType={true}
              flow={"rejectStatementdetails"}
              remitter_account_id={id}
              setViewstatementOpenPop={() => setRejectLiveStatement(false)}
            />
          </LargePopupRedirect>
        </div>
      )}

      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title="Account details updated successfully."
      >
        <TabsWeapperSection title="Updated details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: remitterAccountDetailsData?.name,
                  leftSubTitle: "Account name",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: remitterAccountDetailsData?.id,
                  leftSubTitle: "Account ID",
                  copyText: remitterAccountDetailsData?.id,
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
};

export default RemitterAccountEditSuccess;
